import { ProductKey } from "@/libraries/signup/bxpkit-core/src/constants";

import { OrgBasedProduct } from "../bxp-ui-signup/src";

import {
    UfoCustomDataBundleCohort,
    UfoCustomDataProductCohort,
    UfoCustomDataSiteTypeCohort,
    UfoCohortWebPlatform,
    UfoCustomDataEditionCohort,
    UfoCustomTimingKey
} from "./ufo.types";

export function getProductCohortByKey(
    productKey: ProductKey | OrgBasedProduct | undefined
): UfoCustomDataProductCohort {
    if (!productKey) {
        return "not-found";
    }
    switch (productKey) {
        case ProductKey.CONFLUENCE:
            return "confluence";
        case ProductKey.JIRA_SOFTWARE:
            return "jira-software";
        case ProductKey.JIRA_WORK_MANAGEMENT:
            return "jira-work-management";
        case ProductKey.JIRA_SERVICE_MANAGEMENT:
            return "jira-service-management";
        case ProductKey.JIRA_PRODUCT_DISCOVERY:
            return "jira-product-discovery";
        case ProductKey.OPSGENIE:
            return "opsgenie";
        case ProductKey.LOOM:
            return "loom";
        default:
            return "other";
    }
}

export function getBundleCohort(
    bundle: string | undefined
): UfoCustomDataBundleCohort {
    if (!bundle) {
        return "not-found";
    }
    return bundle as UfoCustomDataBundleCohort;
}

export function getSiteTypeCohort(
    isNewSite: boolean
): UfoCustomDataSiteTypeCohort {
    const siteTypeCohort = isNewSite ? "new-site-n2n" : "existing-site-n2e";
    return siteTypeCohort;
}

export function getWebPlatformCohort(
    webPlatform: string | undefined
): UfoCohortWebPlatform {
    if (!webPlatform) {
        return "unknown";
    }
    return webPlatform as UfoCohortWebPlatform;
}

export function getEdition(
    edition: string | undefined
): UfoCustomDataEditionCohort {
    if (!edition) {
        return "unknown";
    }
    return edition as UfoCustomDataEditionCohort;
}

export function getUfoSubstepForPolling(billingPlatform?: string): {
    timingKey: UfoCustomTimingKey;
    requestPath: string;
} {
    const timingKey =
        billingPlatform === "ccp"
            ? UfoCustomTimingKey.ACTIVATE_STATUS_CCP_POLLING_API
            : UfoCustomTimingKey.CLOUD_STATUS_HAMS_POLLING_API;

    const requestPath =
        billingPlatform === "ccp"
            ? "/activate/status/:provisioningRequestId"
            : "/cofs/:cloudId/status/:requestId";

    return { timingKey, requestPath };
}
